import { AnalyticsCart } from "./analytics-cart";
import { AnalyticsProduct } from "./analytics-product";

export class AnalyticsOrder {
    id: number;
    totalValue: number;
    revenue: number;
    discount: number;
    tax: number;
    cart: Array<AnalyticsProduct>;
    tutorial: boolean;

    constructor(cart: AnalyticsCart, id: number) {
        this.cart = cart.products;
        this.totalValue = 0;
        for (let i = 0; i < this.cart.length; i++) {
            this.totalValue += +this.cart[i].price;
        }
        this.revenue = this.totalValue;
        this.discount = 0;
        this.tax = 0;
        this.id = id;
        if (window.kasickaBetType == "tutorial") {
            this.tutorial = true;
        }
    }
}

export class AnalyticsMultibetOrder {
    id: string;
    totalValue: number;
    revenue: number;
    discount: number;
    tax: number;
    multibetID: number;

    constructor(id: string, totalValue: number, multibetID: number) {
        this.id = id;
        this.totalValue = this.revenue = totalValue;
        this.tax = this.discount = 0;
        this.multibetID = multibetID;
    }
}
